import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function UniqueMechanismSection() {
  return <section className="w-full bg-slate-900 py-16 md:py-24 relative overflow-hidden" data-id="element-164">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-500 via-slate-900 to-slate-900" data-id="element-165"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-slate-800/80 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-amber-500/30 shadow-2xl" data-id="element-167">
          <div className="flex flex-col items-center text-center mb-8" data-id="element-168">
            <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-169">
              <Zap className="w-8 h-8 text-amber-400" data-id="element-170" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-171">
              El Secreto:{' '}
              <span className="text-gold-gradient" data-id="element-172">Velocidad de Flujo</span>
            </h2>
          </div>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed text-center" data-id="element-173">
            El Método "Caja de Oro" se basa en la{' '}
            <strong className="text-amber-400" data-id="element-174">Velocidad de Flujo</strong>. No
            buscamos hacernos ricas con una sola venta; te enseñamos a
            identificar productos de "alta rotación" que se venden en menos de
            24 horas. Usamos el algoritmo de proximidad de Facebook para que los
            compradores locales lleguen a ti, paguen en efectivo y retiren el
            producto en un lugar seguro. Es el negocio más real, rápido y
            tangible que existe hoy para la comunidad latina.
          </p>
        </motion.div>
      </div>
    </section>;
}